module.exports = __webpack_public_path__ + "static/media/corporate-catering-4.caaec155.jpg";